<template>
    <v-dialog v-model="$store.state.Parkland.Match" fullscreen>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">
                    Matched BOL - Unmatched Amounts By Invoice
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.Parkland.Match = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container>
                <v-data-table
                    :headers="headers"
                    :items="Matchs"
                    :search="search"
                    dense
                    height="900px"
                    disable-items-per-page
                    disable-pagination
                    class="custom-table"
                    hide-default-footer
                    :fixed-header="true"
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    label="Search"
                                    v-model="search"
                                    class="mb-5"
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.BillOfLading="{ item }">
                        <td>
                            <v-btn
                                color="primary"
                                dark
                                small
                                @click="openDD(item)"
                                >{{ item.BillOfLading }}</v-btn
                            >
                        </td>
                    </template>

                    <template slot="body.append">
                        <tr>
                            <th class="text-left font-weight-bold" colspan="4">
                                Total
                            </th>
                            <td
                                class="font-weight-bold text-left pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(
                                        Matchs,
                                        'UPTAmt'
                                    ).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                }}
                            </td>
                            <td
                                class="font-weight-bold text-left pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(
                                        Matchs,
                                        'TotalAmountwithTax'
                                    ).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                }}
                            </td>
                            <td
                                class="font-weight-bold text-left pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(
                                        Matchs,
                                        'Diff'
                                    ).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
        <drilldown
            v-if="$store.state.Suncor.Drilldown"
            :dataRow="dataRow"
        ></drilldown>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import drilldown from './DDMatchBOLByInvoice.vue';
export default {
    components: {
        drilldown
    },
    props: ['parms'],
    data: function() {
        return {
            dataRow: null,
            headers: [
                { text: 'InvId', value: 'InvId' },
                { text: 'InvDate', value: 'InvDate' },
                { text: 'Bill Of Lading', value: 'BillOfLading' },
                { text: 'Date Delivered', value: 'DeliveryDate' },
                { text: 'UPT Total', value: 'UPTAmt' },
                { text: 'Pmt Total', value: 'TotalAmountwithTax' },
                { text: 'Diff', value: 'Diff' }
            ],
            Matchs: [],
            Totals: {
                TotalNetAmount: null,
                TotalInvoiceNumber: null,
                TotalDiff: null
            },
            search: ''
        };
    },

    mounted() {
        console.log(this.parms);
        this.getMatchs();
    },
    methods: {
        sumColumn(items, key) {
            return items.reduce(
                (acc, item) => acc + parseFloat(item[key]) || 0,
                0
            );
        },
        openDD: function(item) {
            this.dataRow = item;
            this.$store.state.Suncor.Drilldown = true;
        },
        getMatchs: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('conciliation/parkland/match-data', this.parms)
                .then(async response => {
                    this.Matchs = response.data;
                    // this.Totals = response.data['Totals'];
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
